import A11yDialog from "a11y-dialog";

const mainContent = document.getElementById("main");
export const dialogClass = "dialog";
export const dialogClassMail = `${dialogClass}--mail`;
export const dialogClassCall = `${dialogClass}--call`;

// Contact Dialog
export const contactDialog = document.getElementById("contact-dialog");
export const initContactDialog = new A11yDialog(contactDialog, mainContent);

// Add a new class to the dialog depending of the trigger button purpose
initContactDialog.on("show", (dialogEl, event) => {
  const tab = event.currentTarget.dataset.dialogTab;
  const dialogContent = dialogEl.querySelector(`.${dialogClass}__content`);

  // Remove class in case there are defined by default
  dialogEl.classList.remove(dialogClassCall);
  dialogEl.classList.remove(dialogClassMail);

  // Add the correct class
  dialogEl.classList.add(`${dialogClass}--${tab}`);
  dialogContent.setAttribute("aria-labelledby", `dialog-title-${tab}`);

  // Change dialog tab
  const showForm = document.getElementById("dialog-show-mail");
  const showCall = document.getElementById("dialog-show-call");

  const showFormFn = () => {
    dialogEl.classList.remove(dialogClassCall);
    dialogEl.classList.add(dialogClassMail);
    dialogContent.setAttribute("aria-labelledby", "dialog-title-mail");
  };

  const showCallFn = () => {
    dialogEl.classList.remove(dialogClassMail);
    dialogEl.classList.add(dialogClassCall);
    dialogContent.setAttribute("aria-labelledby", "dialog-title-call");
  };

  if (showForm) showForm.addEventListener("click", showFormFn);
  if (showCall) showCall.addEventListener("click", showCallFn);
});

// Reset class list on close
initContactDialog.on("hide", (dialogEl) => {
  const dialog = dialogEl;
  dialog.className = dialogClass;
});

// Open dialog automatically if URL has block anchor
const hash = window.location.hash;
if (hash && hash.substr(1) == 'call')
  document.querySelector('button[data-dialog-tab="call"]').click();
if (hash && hash.substr(1) == 'mail')
  document.querySelector('button[data-dialog-tab="mail"]').click();

// Overlay exit
document.dialogPreventClosing = false
document.body.addEventListener('click', (e) => {
  if (!e.target.classList.contains('dialog__overlay')) return
  //prevent close when flatpickr is open
  if (document.dialogPreventClosing) return

  initContactDialog.hide();
})

// ESC exit
document.body.addEventListener('keyup', (e) => {
  if (e.key != 'Escape') return
  if (contactDialog.attributes['aria-hidden'] == 'true') return
  //prevent close when flatpickr is open
  if (document.dialogPreventClosing) return

  initContactDialog.hide();
})

export default initContactDialog;
